module.exports = __webpack_public_path__ + "static/media/app.9ff166b8.png";